var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.002 13.504a1.002 1.002 0 100-2.004 1.002 1.002 0 000 2.004zm4.675 0a1.002 1.002 0 100-2.004 1.002 1.002 0 000 2.004zm5.678-1.002a1.002 1.002 0 11-2.004 0 1.002 1.002 0 012.004 0zm3.673 1.002a1.002 1.002 0 100-2.004 1.002 1.002 0 000 2.004z",
    fill: "#fff"
  })));
}
export default SvgSoundOff;